import React from 'react';

const Home = React.lazy(() => import('@/pages/Home/Home'));
const Directory = React.lazy(() => import('@/pages/Directory/Directory'));
const FintechMap = React.lazy(() => import('@/pages/FintechMap/FintechMap'));
const EntityDetail = React.lazy(() => import('@/pages/EntityDetail/EntityDetail'));
const EntityApis = React.lazy(() => import('@/pages/EntityApis/EntityApis'));
const EntityShowcase = React.lazy(() => import('@/pages/EntityShowcase/EntityShowcase'));
const EntityService = React.lazy(() => import('@/pages/EntityService/EntityService'));
const Compare = React.lazy(() => import('@/pages/Compare/Compare'));
const ArticleDetail = React.lazy(() => import('@/pages/ArticleDetail/ArticleDetail'));
const LegalDocument = React.lazy(() => import('@/pages/LegalDocument/LegalDocument'));
const ContactUs = React.lazy(() => import('@/pages/ContactUs/ContactUs'));
const SocialLinkedin = React.lazy(() => import('@/pages/Social/Social'));
const News = React.lazy(() => import('@/pages/News/News'));
const Register = React.lazy(() => import('@/pages/Register/Register'));
const BankDetail = React.lazy(() => import('@/pages/BankDetail/BankDetail'));
const Login = React.lazy(() => import('@/pages/Login/Login'));
const ForgotPassword = React.lazy(() => import('@/pages/ForgotPassword/ForgotPassword'));
const ResetPassword = React.lazy(() => import('@/pages/ResetPassword/ResetPassword'));
const RegisterSuccess = React.lazy(() => import('@/pages/RegisterSuccess/RegisterSuccess'));
const ActivateAccount = React.lazy(() => import('@/pages/ActivateAccount/ActivateAccount'));
const MyOrganisation = React.lazy(() => import('@/pages/MyOrganisation/MyOrganisation'));
const MyPortal = React.lazy(() => import('@/pages/MyPortal/MyPortal'));
const MyApps = React.lazy(() => import('@/pages/MyApps/MyApps'));
const CreateMyApp = React.lazy(() => import('@/pages/CreateMyApp/CreateMyApp'));
const EditMyApp = React.lazy(() => import('@/pages/EditMyApp/EditMyApp'));
const MyDirectory = React.lazy(() => import('@/pages/MyDirectory/MyDirectory'));
const MyAccount = React.lazy(() => import('@/pages/MyAccoount/MyAccount'));
const AddEntity = React.lazy(() => import('@/pages/AddEntity/AddEntity'));
const MyArticles = React.lazy(() => import('@/pages/MyArticles/MyArticles'));
const AddArticle = React.lazy(() => import('@/pages/AddArticle/AddArticle'));
const EditArticle = React.lazy(() => import('@/pages/EditArticle/EditArticle'));
const Standards = React.lazy(() => import('@/pages/Standards/Standards'));
const SocialUser = React.lazy(() => import('@/pages/SocialUser/SocialUser'));
const ApiCategories = React.lazy(() => import('@/pages/ApiCategories/ApiCategories'));
const AppCategories = React.lazy(() => import('@/pages/AppCategories/AppCategories'));
const AddApiCategory = React.lazy(() => import('@/pages/AddApiCategory/AddApiCategory'));
const AddAppCategory = React.lazy(() => import('@/pages/AddAppCategory/AddAppCategory'));
const EditApiCategory = React.lazy(() => import('@/pages/EditApiCategory/EditApiCategory'));
const EditAppCategory = React.lazy(() => import('@/pages/EditAppCategory/EditAppCategory'));
const MyServices = React.lazy(() => import('@/pages/MyServices/MyServices'));
const AddService = React.lazy(() => import('@/pages/AddService/AddService'));
const EditService = React.lazy(() => import('@/pages/EditService/EditService'));
const ServiceCategories = React.lazy(() => import('@/pages/ServiceCategories/ServiceCategories'));
const AddServiceCategory = React.lazy(() => import('@/pages/AddServiceCategory/AddServiceCategory'));
const EditServiceCategory = React.lazy(() => import('@/pages/EditServiceCategory/EditServiceCategory'));
const NotFound404Page = React.lazy(() => import('@/containers/NotFound404/NotFound404'));

export const Paths = {
  Home: '/',
  SocialLinkedin: '/social-linkedin',
  Directory: '/directory',
  DirectoryWithQuery: '/:query',
  DirectoryRegion: '/region',
  DirectoryWithRegion: '/region/:region',
  DirectoryCountry: '/country',
  DirectoryWithCountry: '/country/:country',
  DirectoryWithTag: '/tags/:tag',
  DirectoryWithFeature: '/features/:feature',
  DirectoryFeature: '/features',
  DirectoryTag: '/tags',
  Entity: '/view',
  EntityDetail: '/view/:subdomain',
  EntityApis: '/view/:subdomain/apis',
  EntityShowcase: '/view/:subdomain/showcase',
  EntityService: '/view/:subdomain/services',
  Compare: '/compare',
  CompareWithCountry: '/compare/:countryCode',
  TermsOfUse: '/terms-of-use',
  ContactUs: '/contact-us',
  Standards: '/standards',
  AboutUs: '/about-us',
  PrivacyPolicy: '/privacy-policy',
  FintechMap: '/fintech-map',
  News: '/news',
  ArticleWithTags: '/news/tags/:tagName',
  ArticleTags: '/news/tags',
  Article: '/article',
  OldArticleDetail: '/article/:article',
  ArticleDetail: '/news/:article',
  Auth: '/auth',
  Register: '/register',
  RegisterSuccess: '/register-success',
  BankDetail: '/organization-detail',
  Login: '/login',
  ForgotPassword: '/forgot-password',
  ResetPassword: '/reset-password',
  ActivateAccount: '/activate',
  Dashboard: '/dashboard',
  MyOrganisation: '/my-organisation',
  MyPortal: '/my-portal',
  MyApps: '/my-apps',
  CreateMyApp: '/my-apps/new',
  EditMyApp: '/my-apps/edit/:id',
  MyDirectory: '/my-directory',
  AddEntity: '/my-directory/new',
  MyArticles: '/my-articles',
  AddArticle: '/my-articles/new',
  EditArticle: '/my-articles/edit/:slug',
  SocialUser: '/my-visitors',
  ApiCategories: '/api-categories',
  AppCategories: '/app-categories',
  AddApiCategory: '/api-categories/new',
  AddAppCategory: '/app-categories/new',
  EditApiCategory: '/api-categories/edit/:id',
  EditAppCategory: '/app-categories/edit/:id',
  MyServices: '/my-services',
  AddService: '/my-services/new',
  EditService: '/my-services/edit/:id',
  ServiceCategories: '/service-categories',
  AddServiceCategory: '/service-categories/new',
  EditServiceCategory: '/service-categories/edit/:id',
  GetTheApp: '/get-the-app',
  MyAccount: '/my-account',
  NotFound404Page: '/not-found',
  Rest: '*',
};

export const Pages = {
  Home,
  Directory,
  EntityDetail,
  EntityApis,
  EntityShowcase,
  EntityService,
  Compare,
  ArticleDetail,
  LegalDocument,
  ContactUs,
  Standards,
  SocialLinkedin,
  FintechMap,
  News,
  Register,
  BankDetail,
  Login,
  ForgotPassword,
  ActivateAccount,
  RegisterSuccess,
  MyOrganisation,
  MyPortal,
  MyApps,
  CreateMyApp,
  EditMyApp,
  MyDirectory,
  AddEntity,
  MyArticles,
  AddArticle,
  EditArticle,
  SocialUser,
  ApiCategories,
  AppCategories,
  AddApiCategory,
  AddAppCategory,
  EditApiCategory,
  EditAppCategory,
  MyServices,
  AddService,
  EditService,
  ServiceCategories,
  AddServiceCategory,
  EditServiceCategory,
  ResetPassword,
  MyAccount,
  NotFound404Page,
};
